<ng-container *transloco="let tloco; prefix: 'subscriptions.billing-details'">
  @if (currentBillingEmail$ | async; as billingEmail) {
    <div>
      <span class="text-button">{{ tloco('email.title') }}</span>
      <div class="my-3" [innerHTML]="tloco('current-email', { email: billingEmail })"></div>
      <button type="button" (click)="updateBillingDetails(billingEmail)" mat-stroked-button color="primary">{{ tloco('change') }}</button>
    </div>
  }
</ng-container>
